module.exports = __webpack_public_path__ + "static/media/extra-large.509fff85.png";